import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "../backToTop";
import FooterThree from "@/components/Footer/Footer-Three";

const TermsServices = () => {
  return (
    <>
      <PageHead title="Terms and Conditions - Immigration Guru's"
        description="The terms and conditions governing your use of The Immigration Gurus website, covering intellectual property, liability, privacy and acceptable use." />
      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <div className="container py-5">
            <main id="content" className="site-main">
              <div className="page-header mb-4">
                <h1 className="entry-title h4">Terms and Conditions</h1>
              </div>

              <div className="page-content">
                <p>
                  Welcome to <strong>The Immigration Gurus</strong> (“we,”
                  “our,” or “us”). These Terms &amp; Conditions (“Terms”)
                  govern your use of our website{" "}
                  <a href="https://immigurus.com/" target="_blank" rel="noopener noreferrer">
                    https://immigurus.com/
                  </a>{" "}
                  (the “Website”) and any services, content, or features
                  provided by us.
                </p>

                <p>
                  By accessing or using our Website, you agree to comply with
                  and be bound by these Terms. If you do not agree with these
                  Terms, you must not use our Website.
                </p>

                <hr />
                <h2 className="h4">1. Use of Our Website</h2>
                <p>
                  You agree to use the Website only for lawful purposes and in a
                  way that does not infringe the rights of, restrict, or inhibit
                  anyone else’s use of the Website. Prohibited behavior includes:
                </p>
                <ul>
                  <li>Engaging in any activity that could damage or disrupt the Website.</li>
                  <li>Attempting to gain unauthorized access to any part of the Website or our systems.</li>
                  <li>Using the Website for fraudulent or misleading purposes.</li>
                </ul>

                <hr />
                <h2 className="h4">2. Services and Advice Disclaimer</h2>
                <p>
                  The Immigration Gurus provides immigration-related information
                  and services. While we strive to ensure accuracy, we do not
                  guarantee all information is free from errors. Any reliance is
                  at your own risk.
                </p>
                <p>
                  Immigration laws and regulations are subject to change. We
                  recommend seeking professional advice before making decisions
                  based on this Website.
                </p>

                <hr />
                <h2 className="h4">3. Intellectual Property</h2>
                <p>
                  All content on the Website—including text, graphics, logos,
                  images, videos, and software—is the property of The Immigration
                  Gurus or its suppliers and is protected by copyright and
                  trademark laws.
                </p>

                <hr />
                <h2 className="h4">4. Privacy and Data Protection</h2>
                <p>
                  Your use of the Website is governed by our{" "}
                  <a
                    href="https://immigurus.com/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                  , which explains how we collect, use, and protect your
                  personal information.
                </p>

                <hr />
                <h2 className="h4">5. Limitation of Liability</h2>
                <ul>
                  <li>We are not liable for any damages arising from use or inability to use the Website.</li>
                  <li>We make no warranties about the accuracy or completeness of the Website’s content.</li>
                  <li>We are not responsible for damages from viruses or malware from the Website.</li>
                </ul>

                <hr />
                <h2 className="h4">6. Third-Party Links</h2>
                <p>
                  Our Website may contain links to third-party websites. These
                  are provided for your convenience only; we do not control or
                  endorse their content or practices.
                </p>

                <hr />
                <h2 className="h4">7. Termination of Use</h2>
                <p>
                  We reserve the right to suspend or terminate access without
                  notice if you violate these Terms or engage in harmful conduct.
                </p>

                <hr />
                <h2 className="h4">8. Changes to These Terms</h2>
                <p>
                  We may update these Terms from time to time. Continued use of
                  the Website after changes means you accept the new Terms.
                </p>

                <hr />
                <h2 className="h4">9. Governing Law</h2>
                <p>
                  These Terms are governed by the laws of [Insert Jurisdiction],
                  without regard to conflict of law principles.
                </p>

                <hr />
                <h2 className="h4">10. Contact Us</h2>
                <ul>
                  <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:contact@immigurus.co">contact@immigurus.co</a>
                  </li>
                  <li>
                    <strong>Visit:</strong>{" "}
                    <a
                      href="https://immigurus.com/contact-us/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://immigurus.com/contact-us/
                    </a>
                  </li>
                  <li>
                    <strong>Phone:</strong> +91 93380-00045
                  </li>
                </ul>
              </div>
            </main>
          </div>

          <Cart />
          <BackToTop />
          <FooterThree />
        </Context>
      </Provider>
    </>
  );
};

export default TermsServices;
